import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminMateriaPrima: Routes = [
  {
    path: 'materia_prima',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'MATERIA',
      module: 'MATERIA_PRIMA',
      breadcrumb: {
        label: 'Matéria Prima',
        icon: 'mdi mdi-shape-outline'
      },
      backend_path: '/materia_primas'
    },
    loadChildren: () =>
      import('@app/modules/materia-prima/materia_prima.module').then(
        m => m.MateriaPrimaModule
      )
  },
  {
    path: 'materia_prima_variacoes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'MATERIA',
      module: 'GRADE_MATERIA_PRIMA',
      breadcrumb: {
        label: 'Grade de matéria prima',
        icon: 'mdi mdi-sitemap'
      },
      backend_path: '/materia_prima_variacoes'
    },
    loadChildren: () =>
      import('@app/modules/materia-prima/materia_prima_grade.module').then(
        m => m.MateriaPrimaGradeModule
      )
  },
  {
    path: 'saida_materiais',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      breadcrumb: {
        label: 'Saídas',
        icon: 'mdi mdi-archive-arrow-up-outline'
      },
      module: 'RSE_MATERIA',
      backend_path: '/rses'
    },
    loadChildren: () =>
      import('@app/modules/saida-materiais/saida.module').then(
        m => m.SaidaMateriaisModule
      )
  },
  {
    path: 'ajuste_estoque',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      breadcrumb: {
        label: 'Ajuste de estoque',
        icon: 'mdi mdi-archive-edit-outline'
      },
      module: 'AJUSTE_ESTOQUE',
      backend_path: '/ajuste_materias'
    },
    loadChildren: () =>
      import('@modules/ajuste_estoque/ajuste_estoque.module').then(
        m => m.AjusteEstoqueModule
      )
  },
  {
    path: 'conversao_materia_prima',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      breadcrumb: {
        label: 'Transformação de matéria prima',
        icon: 'mdi mdi-swap-horizontal'
      },
      module: 'TMP_MATERIA',
      backend_path: '/tmps'
    },
    loadChildren: () =>
      import('@modules/conversao-materia/conversao-materia.module').then(
        m => m.ConversaoMateriaModule
      )
  },
  {
    path: 'entrada_materiais',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      breadcrumb: {
        label: 'Entradas',
        icon: 'mdi mdi-archive-arrow-down-outline'
      },
      module: 'REE_MATERIA',
      backend_path: '/rees'
    },
    loadChildren: () =>
      import('@app/modules/entrada-materiais/entrada.module').then(
        m => m.EntradaMateriaisModule
      )
  },
  {
    path: 'categoria_materia_primas',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      preload: false,
      breadcrumb: {
        label: 'Categoria de matérias primas',
        icon: 'mdi mdi-shape-outline'
      },
      module: 'CATEGORIA_MATERIA',
      backend_path: '/categoria_materia_primas'
    },
    loadChildren: () =>
      import(
        '@app/modules/categoria-materia-prima/categoria_materia_prima.module'
      ).then(m => m.CategoriaMateriaPrimaModule)
  },
  {
    path: 'variacao_materia_prima',
    canActivate: [RenderInterfaceGuard],
    data: {
      menuKey: 'MATERIA',
      preload: false,
      breadcrumb: {
        label: 'Variações matéria prima',
        icon: 'mdi mdi-vector-difference-ba'
      },
      module: 'VARIACAO_MATERIA'
    },
    loadChildren: () =>
      import('@app/modules/variacao-materias/variacao-materias.module').then(
        m => m.VariacaoMateriasModule
      )
  }
];
